module.exports = __webpack_public_path__ + "static/macbook_pro_retina@1x-92415aeb595e10a0ebe4cecf8b704929.png";